import { css } from 'lit';

export const styles = css`[part~=dragging] igc-textarea::part(container){background:var(--box-background-focus)}[part~=dragging] igc-textarea::part(container)::after{border-block-end:.125rem solid var(--focused-bottom-line-color)}igc-textarea::part(input){margin-block-start:unset;padding-block:.75rem}`;
